// extracted by mini-css-extract-plugin
module.exports = {"screenblocker":"screenblocker_screenblocker__TBNdg","info":"screenblocker_info__3VUqV","fadeIn":"screenblocker_fadeIn__xkngM"};